export default __webpack_public_path__ + "static/media/kerjoo-desk-logo.941190b1.png";